import React, { Component } from "react";
import { connect } from "react-redux";
import {
  fetchBinItemsThunk,
  binPickingThunk,
} from "../../../../redux/TOThunks/Action";
import { TaskIdCheck } from "../../components/TaskIdCheck/TaskIdCheck";
import { Result, message } from "antd";
import TMLoader from "../../../../components/Loader/Loader";
import BinTable from "../../components/BinTable/BinTable";
import TOQtyModal from "../../components/TOQtyModal/TOQtyModal";
import { IoArrowBackCircle } from "react-icons/io5";
import { BinComplete, TOBPBack } from "./TOBPMed.style";
import { withRouter } from "react-router-dom/cjs/react-router-dom";
import { fetchBinItems } from "../../service/service";
import { API_TYPE, warehouseId } from "../../../../constants";
import { handleError } from "../../../../redux/makeApiCall";
import { getAllReasons } from "../../helper/binHelper";
export class TOBPMed extends Component {
  state = {
    pageLoading: false,
    medData: [],
    selectedRecord: null,
    pickingDone: false,
    reasonMaster: {
      moreQtyReasons: [],
      lessQuantityReasons: [],
      rackerReasons: [],
    },
  };

  componentDidMount = () => {
    this.getBinCall();
    this.fetchReasons();
  };
  fetchReasons = async () => {
    const { lessQuantityReasons, moreQtyReasons } = await getAllReasons({
      access_token: this.props.access_token,
      isRacker: false,
    });
    this.setState({
      reasonMaster: {
        ...this.state.reasonMaster,
        lessQuantityReasons,
        moreQtyReasons,
      },
    });
  };
  getBinCall = () => {
    this.setState({
      pageLoading: true,
    });

    if (TaskIdCheck) {
      fetchBinItems({
        access_token: this.props.access_token,
        binNumber: localStorage.getItem("selectedBin"),
        warehouseId: warehouseId,
        taskId: localStorage.getItem("taskId"),
      })
        .then((response) => {
          if (response.status === 200 && response.data?.statusCode === 200) {
            const medData = response.data.responseData.data;
            this.setState({
              pageLoading: false,

              medData,
            });
          } else if (
            response.status === 200 &&
            response.data?.statusCode === 204
          ) {
            const pickedData = response.data?.responseData?.pickedData || [];
            this.setState({
              pageLoading: false,

              medData: [],
              pickingDone: pickedData?.some(
                (k) => localStorage.getItem("selectedBin") === k.binNumber
              ),
            });
          }
          return;
          this.setState({
            pageLoading: false,
          });
          if (this.props.TOReducer?.GetBinErr) {
            message.error(this.props.TOReducer?.GetBinErr);
            this.setState({
              medData: null,
            });
          } else {
            let medData = [];

            this.props.TOReducer?.GetBinData?.map((k) =>
              medData.push({
                ...k,
                disabled: k.availableQty == 0,
              })
            );

            this.setState({
              medData,
              pickingDone:
                medData?.filter((k) => k.disabled)?.length == medData?.length,
            });
          }
        })
        .catch((error) => {
          message.error(handleError(error, API_TYPE.NEW));
          this.setState({ pageLoading: false });
        });
    }
  };

  rowClickHandler = ({ disabled, ...record }) => {
    if (disabled) {
      message.error("Already Racked");
      return;
    }
    this.setState({
      selectedRecord: { isSelected: true, ...record },
    });
  };

  binPicking = (selectedQty, selectedReason, selectedRack) => {
    this.setState({
      pageLoading: true,
    });

    let { selectedRecord } = this.state;
    this.props
      .binPickingThunk({
        access_token: this.props.access_token,
        taskId: localStorage.getItem("taskId"),
        medData: [
          {
            productName: selectedRecord?.productName,
            productCode: selectedRecord?.productCode,
            batchNumber: selectedRecord?.batchNumber,
            binNumber: selectedRecord?.binNumber,
            binLocation: selectedRecord?.binLocation,
            availableQty: selectedQty,
            reasonId: selectedReason,
            expiryDate: selectedRecord?.expiryDate,
          },
        ],
      })
      .then(() => {
        this.setState({
          pageLoading: false,
        });
        if (this.props.TOReducer?.BinPickErr) {
          message.error(this.props.TOReducer?.BinPickErr);
        } else {
          this.setState({
            selectedRecord: null,
          });
          message.success("Updated Successfully");
          this.getBinCall();
        }
      });
  };

  render() {
    let { pageLoading, medData, selectedRecord, pickingDone } = this.state;
    const columns = [
      {
        title: "Product Name",
        dataIndex: "productName",
        key: "productName",
        align: "center",
        filter: true,
      },
      {
        title: "Batch Number",
        dataIndex: "batchNumber",
        key: "batchNumber",
        align: "center",
      },
      {
        title: "Pending Quantity",
        dataIndex: "availableQty",
        key: "availableQty",
        align: "center",
      },
    ];

    return (
      <>
        {pageLoading ? <TMLoader /> : null}

        {pickingDone ? (
          <BinComplete
            status="success"
            title="Bin Picking Complete !"
            extra={
              <button
                className="bbtn"
                disabled={pageLoading}
                onClick={() => this.props.history.push("/to-bin-picker")}
              >
                Go to home
              </button>
            }
          />
        ) : (
          <>
            <TOBPBack onClick={() => this.props.history.push("/to-bin-picker")}>
              <IoArrowBackCircle /> Back
            </TOBPBack>

            <BinTable
              columns={columns}
              dataSource={medData}
              onRowClick={this.rowClickHandler}
            />
          </>
        )}

        {selectedRecord ? (
          <TOQtyModal
            confirm={this.binPicking}
            close={() => this.setState({ selectedRecord: null })}
            data={selectedRecord}
            reasonMaster={this.state.reasonMaster}
          />
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  TOReducer: state.TOReducer,
});

const mapDispatchToProps = { fetchBinItemsThunk, binPickingThunk };

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TOBPMed)
);
